import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "@babel/runtime/helpers/esm/toArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';

var pipeP = function pipeP() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(v) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", fns.reduce( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r, fn) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.t0 = fn;
                          _context.next = 3;
                          return r;

                        case 3:
                          _context.t1 = _context.sent;
                          return _context.abrupt("return", (0, _context.t0)(_context.t1));

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2, _x3) {
                  return _ref2.apply(this, arguments);
                };
              }(), v));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Doplni autentifikacni kontext o `user`, `scope` a `meta` v ramci autentizacniho pipeline. Nebo zavola
 * `logout` pokud je uzivatel odhlasen.
 */


function AuthHandler(_ref3) {
  var children = _ref3.children,
      client = _ref3.client,
      ignoreContextAccessToken = _ref3.ignoreContextAccessToken,
      onAuth = _ref3.onAuth,
      onAuthData = _ref3.onAuthData,
      onLogout = _ref3.onLogout,
      onMeta = _ref3.onMeta,
      onScope = _ref3.onScope,
      onTokenPayload = _ref3.onTokenPayload,
      registerOnAuthenticate = _ref3.registerOnAuthenticate,
      registerOnLogout = _ref3.registerOnLogout;

  var handleAuth = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(ctx) {
      var credentials, pAccessToken, _ctx$meta, parentTokenPyalod, _yield$pipeP, _yield$pipeP2, accessToken, tokenPayload, user, scope, meta;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              credentials = ctx.credentials, pAccessToken = ctx.accessToken, _ctx$meta = ctx.meta;
              _ctx$meta = _ctx$meta === void 0 ? {} : _ctx$meta;
              parentTokenPyalod = _ctx$meta.tokenPayload;
              invariant(pAccessToken || onAuth, 'AuthHandler requires `tokenPayload` from `ctx` or `onAuth` handler to be defined.');
              _context9.prev = 4;
              _context9.next = 7;
              return pipeP( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(pat) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", (pat && !ignoreContextAccessToken ? [pat] : onAuth(client, credentials)).then(function (r) {
                            return r ? function (_ref6) {
                              var at = _ref6.accessToken,
                                  m = _ref6.meta,
                                  s = _ref6.scope,
                                  tp = _ref6.tokenPayload,
                                  u = _ref6.user;
                              return [at, tp, u, s, m];
                            }(r) : [];
                          }));

                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }(), /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(p) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          client.setAccessToken(p[0]);
                          return _context4.abrupt("return", p);

                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x6) {
                  return _ref7.apply(this, arguments);
                };
              }(), /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref8) {
                  var _ref10, at, tp, rest;

                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _ref10 = _toArray(_ref8), at = _ref10[0], tp = _ref10[1], rest = _ref10.slice(2);
                          invariant(ignoreContextAccessToken && (tp || onTokenPayload) || !ignoreContextAccessToken && (parentTokenPyalod || tp || onTokenPayload), 'AuthHandler requires `onAuthData` callback prop to be defined or `onAuth` have to return `user` as part of result Object.');
                          _context5.t0 = at;
                          _context5.t1 = (!ignoreContextAccessToken ? parentTokenPyalod : undefined) || tp;

                          if (_context5.t1) {
                            _context5.next = 8;
                            break;
                          }

                          _context5.next = 7;
                          return onTokenPayload(client, at);

                        case 7:
                          _context5.t1 = _context5.sent;

                        case 8:
                          _context5.t2 = _context5.t1;
                          _context5.t3 = _toConsumableArray(rest);
                          return _context5.abrupt("return", [_context5.t0, _context5.t2].concat(_context5.t3));

                        case 11:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));

                return function (_x7) {
                  return _ref9.apply(this, arguments);
                };
              }(), /*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
                  var _ref13, at, tp, u, rest;

                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _ref13 = _toArray(_ref11), at = _ref13[0], tp = _ref13[1], u = _ref13[2], rest = _ref13.slice(3);
                          invariant(onAuthData || u, 'AuthHandler requires `onAuthData` callback prop to be defined or `onAuth` have to return `user` as part of result Object.');
                          _context6.t0 = at;
                          _context6.t1 = tp;
                          _context6.t2 = u;

                          if (_context6.t2) {
                            _context6.next = 9;
                            break;
                          }

                          _context6.next = 8;
                          return onAuthData(client, at, tp);

                        case 8:
                          _context6.t2 = _context6.sent;

                        case 9:
                          _context6.t3 = _context6.t2;
                          _context6.t4 = _toConsumableArray(rest);
                          return _context6.abrupt("return", [_context6.t0, _context6.t1, _context6.t3].concat(_context6.t4));

                        case 12:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                return function (_x8) {
                  return _ref12.apply(this, arguments);
                };
              }(), /*#__PURE__*/function () {
                var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref14) {
                  var _ref16, at, tp, u, s, rest;

                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _ref16 = _toArray(_ref14), at = _ref16[0], tp = _ref16[1], u = _ref16[2], s = _ref16[3], rest = _ref16.slice(4);
                          invariant(onAuthData || u, 'AuthHandler requires `onScope` callback prop to be defined or `onAuth` have to return `scope` as part of result Object.');
                          _context7.t0 = at;
                          _context7.t1 = tp;
                          _context7.t2 = u;
                          _context7.t3 = s;

                          if (_context7.t3) {
                            _context7.next = 10;
                            break;
                          }

                          _context7.next = 9;
                          return onScope(client, at, tp);

                        case 9:
                          _context7.t3 = _context7.sent;

                        case 10:
                          _context7.t4 = _context7.t3;
                          _context7.t5 = _toConsumableArray(rest);
                          return _context7.abrupt("return", [_context7.t0, _context7.t1, _context7.t2, _context7.t4].concat(_context7.t5));

                        case 13:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }));

                return function (_x9) {
                  return _ref15.apply(this, arguments);
                };
              }(), /*#__PURE__*/function () {
                var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref17) {
                  var _ref19, at, tp, u, s, m;

                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          _ref19 = _slicedToArray(_ref17, 5), at = _ref19[0], tp = _ref19[1], u = _ref19[2], s = _ref19[3], m = _ref19[4];
                          _context8.t0 = at;
                          _context8.t1 = tp;
                          _context8.t2 = u;
                          _context8.t3 = s;
                          _context8.t4 = m;

                          if (_context8.t4) {
                            _context8.next = 15;
                            break;
                          }

                          if (!onMeta) {
                            _context8.next = 13;
                            break;
                          }

                          _context8.next = 10;
                          return onMeta(client, at, tp);

                        case 10:
                          _context8.t5 = _context8.sent;
                          _context8.next = 14;
                          break;

                        case 13:
                          _context8.t5 = undefined;

                        case 14:
                          _context8.t4 = _context8.t5;

                        case 15:
                          _context8.t6 = _context8.t4;
                          return _context8.abrupt("return", [_context8.t0, _context8.t1, _context8.t2, _context8.t3, _context8.t6]);

                        case 17:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8);
                }));

                return function (_x10) {
                  return _ref18.apply(this, arguments);
                };
              }())(pAccessToken);

            case 7:
              _yield$pipeP = _context9.sent;
              _yield$pipeP2 = _slicedToArray(_yield$pipeP, 5);
              accessToken = _yield$pipeP2[0];
              tokenPayload = _yield$pipeP2[1];
              user = _yield$pipeP2[2];
              scope = _yield$pipeP2[3];
              meta = _yield$pipeP2[4];
              return _context9.abrupt("return", _extends({}, ctx, {
                accessToken: accessToken,
                scope: scope || [''],
                meta: _extends({}, ctx.meta, {
                  tokenPayload: tokenPayload
                }, meta),
                user: user,
                isAuthenticated: true
              }));

            case 17:
              _context9.prev = 17;
              _context9.t0 = _context9["catch"](4);
              return _context9.abrupt("return", {
                error: _context9.t0
              });

            case 20:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[4, 17]]);
    }));

    return function handleAuth(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleLogout = /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", onLogout());

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function handleLogout() {
      return _ref20.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    var _ref21 = Array.isArray(registerOnAuthenticate) ? registerOnAuthenticate : [registerOnAuthenticate],
        _ref22 = _slicedToArray(_ref21, 2),
        f = _ref22[0],
        s = _ref22[1];

    var handler = typeof f === 'number' ? s : f;
    var order = typeof f === 'number' ? f : s;
    handler(handleAuth, order);
    if (registerOnLogout) registerOnLogout(handleLogout);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return children;
} // ***************
// ***************


AuthHandler.propTypes = {
  /**
   * Renderovany obsah.
   */
  children: PropTypes.node,

  /**
   * API client.
   */
  client: PropTypes.shape({}).isRequired,
  ignoreContextAccessToken: PropTypes.bool,

  /**
   * Handler pro ziskani autentifikacniho tokenu, pripadne veskerych dat.
   *
   * Je potreba definovat pokud autentifikacni token neni soucasti ctx.
   *
   * Pokud neni definovano a soucasti ctx neni access token dochazi k chybe.
   *
   * Signatura: `(client: Object, credentials: { username: string, password: string }) => Promise<{ accessToken: string, meta?: Object, scope?: atring | Arra<string>, tokenPayload?: Object, user?: Object }>`
   */
  onAuth: PropTypes.func,

  /**
   * Handler pro ziskani objektu uzivatele.
   *
   * Handler je volan po ziskani obsahu tokenu.
   *
   * Signatura funkce: `(client: Object, accressToken: string, tokenPayload: ?Object) => Promise<User>`
   */
  onAuthData: PropTypes.func,

  /**
   * Handler pro ziskani payloadu tokenu. Vola se jako prvni handler pipe a to v pripade, ze auth context neobsahuje
   * `tokenPayload`.
   */
  onLogout: PropTypes.func.isRequired,

  /**
   * Handler pro ziskani metadat. Pokud je definovan, vola se jako posladni.
   *
   * Signatura funkce: `(client: Object, accressToken: string, tokenPayload: ?Object) => Promise<Object>`
   */
  onMeta: PropTypes.func,

  /**
   * Handler pro ziskani scope. Vola
   *
   * Signatura funkce: `(client: Object, accressToken: string, tokenPayload: ?Object) => Promise<string | Array<string>>`
   */
  onScope: PropTypes.func,

  /**
   * Handler pro odhlaseni uzivatele.
   *
   * Signatura: `(client: Object, accressToken: string) => Promise<Object>`
   */
  onTokenPayload: PropTypes.func,

  /**
   * Registrace handleru do `Authenticate` auth pipeline.
   * Vstupem je registracni metoda se signaturou ``
   *
   * Signatura hanlder metody: `(ctx) => Promise<ctx>`
   */
  registerOnAuthenticate: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,

  /**
   * Registrace handleru do `Authenticate` logout pipeline.
   * Signatura hanlder metody: `() => Promise`
   */
  registerOnLogout: PropTypes.func.isRequired
}; // ***************
// ***************

AuthHandler.defaultProps = {
  children: null,
  ignoreContextAccessToken: false,
  onAuth: undefined,
  onAuthData: undefined,
  onMeta: undefined,
  onScope: undefined,
  onTokenPayload: undefined
};
export default AuthHandler;